// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  */
.contact-us-page {
  background: var(--bv-bg-cream);
  min-height: 60vh;
  overflow-x: clip;
}

.contact-hero {
  position: relative;
  overflow: hidden;
  padding: clamp(1.75rem, 4vw, 3rem) 0 clamp(1.5rem, 3vw, 2.25rem);
  background: linear-gradient(165deg, var(--bv-bg) 0%, var(--bv-primary-50) 45%, var(--bv-bg-cream) 100%);
  border-bottom: 1px solid var(--bv-line-soft);
}

.contact-hero__inner {
  position: relative;
  z-index: 1;
}

.contact-hero__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: clamp(1rem, 2vw, 1.75rem);
  align-items: center;
}

.contact-hero__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  background: transparent;
  box-shadow: none;
  border: 0;
  animation: none;
}

.contact-hero__visual {
  width: 100%;
  min-width: 0;
  line-height: 0;
  animation: none;
}

.contact-hero__img {
  display: block;
  width: 100%;
  height: auto;
  max-width: none;
  object-fit: contain;
  object-position: center right;
  border-radius: 20px;
}

.contact-breadcrumb {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: var(--bv-text-sm);
  margin-bottom: var(--bv-space-4);
}

.contact-breadcrumb__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--bv-muted);
  font-weight: 500;
  transition: color var(--bv-dur) var(--bv-ease);
}

.contact-breadcrumb__link:hover {
  color: var(--bv-primary-700);
}

.contact-breadcrumb__link i {
  font-size: 0.75rem;
  color: var(--bv-primary);
}

.contact-breadcrumb__sep {
  color: var(--bv-muted-2);
  font-size: 0.65rem;
}

.contact-breadcrumb__current {
  color: var(--bv-ink);
  font-weight: 600;
}

.contact-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  margin-bottom: var(--bv-space-4);
  animation: bvFadeUp 0.6s var(--bv-ease-out) both;
}

.contact-hero__eyebrow i {
  color: var(--bv-primary);
  font-size: 0.85rem;
}

.contact-hero__title {
  font-family: var(--bv-font-display);
  font-size: clamp(2rem, 3.2vw, 3rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.08;
  color: var(--bv-ink);
  margin: 0 0 var(--bv-space-4);
  max-width: 12ch;
  animation: bvFadeUp 0.65s var(--bv-ease-out) 0.05s both;
}

.contact-hero__lede {
  font-size: var(--bv-text-lg);
  color: var(--bv-muted);
  line-height: 1.7;
  max-width: 54ch;
  margin: 0;
  animation: bvFadeUp 0.7s var(--bv-ease-out) 0.1s both;
}

/* contact-us */
.content.contact-group {
  padding: 80px 0px 0px;
}

.contact-intro {
  text-align: center;
  max-width: 780px;
  margin: 0 auto 46px;
}

.contact-intro h1 {
  font-size: clamp(2rem, 2.5vw, 3rem);
  line-height: 1.05;
  margin-bottom: 1rem;
  color: #092642;
}

.contact-intro p {
  color: #52606d;
  font-size: 1rem;
  max-width: 640px;
  margin: 0 auto;
}

.contact-success-banner {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #064e3b;
  padding: 16px 24px;
  border-radius: 16px;
  margin-bottom: 32px;
  text-align: center;
  font-weight: 500;
}

.contact-card-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin-bottom: 48px;
}

.contact-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.08);
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.contact-card-icon {
  min-width: 64px;
  min-height: 64px;
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  color: #ffffff;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
}

.contact-card-content h4 {
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  color: #10375c;
}

.contact-card-content p {
  margin: 0;
  color: #5b6674;
  line-height: 1.7;
}

.contact-us-page a {
  color: #14b8a6;
}

.contact-section-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 32px;
  align-items: start;
}

.contact-us-form {
  padding: 32px;
  background: #ffffff;
  border-radius: 30px;
  box-shadow: 0 26px 70px rgba(15, 23, 42, 0.08);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-group-fullwidth {
  grid-column: 1 / -1;
}

.contact-us-form .form-control {
  width: 100%;
  padding: 16px 18px;
  border-radius: 16px;
  background: #f7fafc !important;
  border: 1px solid #dbe4ea;
  color: #152a3a;
}

.contact-us-form .form-control:focus {
  border-color: #0d9488;
  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12) !important;
}

.contact-us-form .form-label {
  color: #344054;
  font-weight: 600;
}

.contact-us-page .contact-us-form .btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 22px;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  border-color: transparent;
  color: #ffffff;
  font-weight: 700;
  border-radius: 16px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.contact-us-page .contact-us-form .btn-secondary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 18px 40px rgba(20, 184, 166, 0.22);
}

.contact-aside-panel {
  display: grid;
  gap: 24px;
}

.contact-aside-card,
.contact-map-card {
  background: #ffffff;
  border-radius: 28px;
  padding: 28px;
  box-shadow: 0 24px 62px rgba(15, 23, 42, 0.08);
}

.contact-aside-card h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  font-size: 1.4rem;
  color: #092642;
}

.contact-aside-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 20px;
}

.contact-aside-item:last-child {
  margin-bottom: 0;
}

.contact-aside-icon {
  width: 52px;
  min-width: 52px;
  height: 52px;
  border-radius: 20px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  color: #ffffff;
  font-size: 1.2rem;
}

.contact-aside-item h4 {
  margin: 0 0 6px;
  font-size: 1rem;
  color: #0f172a;
}

.contact-aside-item p {
  margin: 0;
  color: #5b6674;
  line-height: 1.8;
}

.contact-map-card {
  padding: 0;
  overflow: hidden;
}

.contact-map-card iframe {
  width: 100%;
  height: 100%;
  min-height: 340px;
  border: none;
  display: block;
}

.contact-dull-bg {
  background: #f8fafc;
  position: relative;
  padding: 80px 0;
}

.contact-dull-bg h2 {
  color: #092642;
  font-weight: 700;
  max-width: 640px;
  font-size: clamp(2rem, 2.5vw, 2.5rem);
  text-align: center;
  margin: 0 auto 40px;
}

@media (max-width: 1024px) {
  .contact-section-grid {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .contact-card-grid {
    grid-template-columns: 1fr;
  }

  .contact-hero__body {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .contact-dull-bg {
    padding: 60px 0;
  }

  .contact-us-form,
  .contact-aside-card,
  .contact-map-card {
    border-radius: 24px;
    padding: 24px;
  }

  .contact-aside-card h3 {
    font-size: 1.25rem;
  }

  .contact-hero__title {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .contact-intro {
    margin-bottom: 32px;
  }

  .contact-us-page .contact-us-form .btn-secondary {
    padding: 14px;
  }
}

.contact-us-page .details .info {
  margin-left: 15px;
}

.contact-us-page .details .contact-icon {
  width: 80px;
  min-width: 80px;
  height: 80px;
  background: linear-gradient(93.86deg, #006177 -2.6%, #269089 67.39%, #7ABC82 110.84%);
  border-radius: 10px;
  font-size: 33px;
  color: #FFFFFF;
}

.contact-us-page .details:hover .contact-icon {
  background: linear-gradient(105.55deg, #7ABC82 -6.68%, #269089 43.13%, #085A6C 96.15%);
}

.contact-us-page .details .info p {
  margin-bottom: 0;
  color: #6B7385;
  font-size: 15px;
}

a {
  color: #6B7385;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.5s ease-in-out 0s;
}

.content.contact-group .google-maps {
  margin-bottom: 80px;
}

.form-control:focus {
  box-shadow: none !important;
  border: none !important;
}

.support-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.support-list li {
  position: relative;
  /* background: #111; */
  color: #111;
  margin-bottom: 12px;
  padding: 14px 18px 14px 50px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  transition: 0.3s ease;
  border: 1px solid #222;
}

.support-list li::before {
  content: "✔";
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  background: #00c853;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.support-list li:hover {
  transform: translateX(6px);
  border-color: #333;
}


/* contact-form */
.contact-dull-bg {
  background: #F9F9F6;
  position: relative;
  padding: 80px 0;
}

.contact-dull-bg h2 {
   color: #092642;
  font-weight: 600;
  max-width: 600px;
  font-size: 32px;
  text-align: center;
  margin: 0 auto 16px;
}

.contact-us-form {
  padding: 24px;
  background: #FFFFFF;
}

form label.form-label {
  margin-bottom: 10px;
  color: #192335;
}

form label,
form input {
  color: #192335;
}

label {
  display: inline-block;
}


h4 {
  font-weight: 600;
  font-size: 20px;
  color: #192335;
}

form input.form-control,
form textarea.form-control {
  padding: 20px;
  border-radius: 10px;
  background: #f0f0f0 !important;
  border: none;
  font-weight: 500;
}

.contact-us-page .contact-us-form button {
  margin: 24px auto 0 auto;
}

.contact-us-page .contact-us-form .btn-secondary {
  color: #FFFFFF;
  background: #00bfb4;
  border-color: #00bfb4;
}

.contact-us-page .contact-us-form .btn {
  font-size: 16px;
  padding: 12px 20px;
  font-weight: 500;
  border-radius: 10px;
  transition: all 0.5s ease-in-out 0s;
}

/* contact-form */


@media screen and (max-width: 1199.98px) {
  .breadcrumb:before {
    top: 24px;
    left: 24px;
  }

  .breadcrumb span.primary-right-round {
    top: 80px;
  }
}

@media screen and (max-width: 991.98px) {
  .contact-us-page .details {
    margin-bottom: 15px;
  }

  h1 {
    font-size: 32px;
  }

  .content.contact-group {
    padding: 60px 0px 0px;
  }

  h2 {
    font-size: 30px !important;
  }

  h4 {
    font-size: 18px !important;
  }
}

@media screen and (max-width: 767.98px) {
  .content {
    padding: 40px 0;
  }

  h2 {
    font-size: 27px !important;
  }

}



@media screen and (max-width: 676.98px) {
  .contact-us-page .details svg {
    height: 1.9rem !important;
    width: 1.9rem !important;
  }

  .breadcrumb-item a {
    font-size: 0.8rem !important;
  }
}

@media(max-width: 575.98px){
  .text-center{
    padding: 0px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/ContactusPage.css"],"names":[],"mappings":"AAAA,KAAK;AACL;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,uGAAuG;EACvG,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,qDAAqD;AACvD;;AAEA,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qFAAqF;EACrF,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EAGrB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;;AAGA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;GACG,cAAc;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EAGnB,mCAAmC;AACrC;;AAEA,iBAAiB;;;AAGjB;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;AAEF;;;;AAIA;EACE;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/*  */\n.contact-us-page {\n  background: var(--bv-bg-cream);\n  min-height: 60vh;\n  overflow-x: clip;\n}\n\n.contact-hero {\n  position: relative;\n  overflow: hidden;\n  padding: clamp(1.75rem, 4vw, 3rem) 0 clamp(1.5rem, 3vw, 2.25rem);\n  background: linear-gradient(165deg, var(--bv-bg) 0%, var(--bv-primary-50) 45%, var(--bv-bg-cream) 100%);\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.contact-hero__inner {\n  position: relative;\n  z-index: 1;\n}\n\n.contact-hero__body {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n  gap: clamp(1rem, 2vw, 1.75rem);\n  align-items: center;\n}\n\n.contact-hero__content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n  border: 0;\n  animation: none;\n}\n\n.contact-hero__visual {\n  width: 100%;\n  min-width: 0;\n  line-height: 0;\n  animation: none;\n}\n\n.contact-hero__img {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-width: none;\n  object-fit: contain;\n  object-position: center right;\n  border-radius: 20px;\n}\n\n.contact-breadcrumb {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  margin-bottom: var(--bv-space-4);\n}\n\n.contact-breadcrumb__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--bv-muted);\n  font-weight: 500;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n\n.contact-breadcrumb__link:hover {\n  color: var(--bv-primary-700);\n}\n\n.contact-breadcrumb__link i {\n  font-size: 0.75rem;\n  color: var(--bv-primary);\n}\n\n.contact-breadcrumb__sep {\n  color: var(--bv-muted-2);\n  font-size: 0.65rem;\n}\n\n.contact-breadcrumb__current {\n  color: var(--bv-ink);\n  font-weight: 600;\n}\n\n.contact-hero__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  margin-bottom: var(--bv-space-4);\n  animation: bvFadeUp 0.6s var(--bv-ease-out) both;\n}\n\n.contact-hero__eyebrow i {\n  color: var(--bv-primary);\n  font-size: 0.85rem;\n}\n\n.contact-hero__title {\n  font-family: var(--bv-font-display);\n  font-size: clamp(2rem, 3.2vw, 3rem);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.08;\n  color: var(--bv-ink);\n  margin: 0 0 var(--bv-space-4);\n  max-width: 12ch;\n  animation: bvFadeUp 0.65s var(--bv-ease-out) 0.05s both;\n}\n\n.contact-hero__lede {\n  font-size: var(--bv-text-lg);\n  color: var(--bv-muted);\n  line-height: 1.7;\n  max-width: 54ch;\n  margin: 0;\n  animation: bvFadeUp 0.7s var(--bv-ease-out) 0.1s both;\n}\n\n/* contact-us */\n.content.contact-group {\n  padding: 80px 0px 0px;\n}\n\n.contact-intro {\n  text-align: center;\n  max-width: 780px;\n  margin: 0 auto 46px;\n}\n\n.contact-intro h1 {\n  font-size: clamp(2rem, 2.5vw, 3rem);\n  line-height: 1.05;\n  margin-bottom: 1rem;\n  color: #092642;\n}\n\n.contact-intro p {\n  color: #52606d;\n  font-size: 1rem;\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.contact-success-banner {\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  color: #064e3b;\n  padding: 16px 24px;\n  border-radius: 16px;\n  margin-bottom: 32px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.contact-card-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  margin-bottom: 48px;\n}\n\n.contact-card {\n  background: #ffffff;\n  border-radius: 24px;\n  padding: 28px 24px;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.08);\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.contact-card-icon {\n  min-width: 64px;\n  min-height: 64px;\n  border-radius: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.6rem;\n  color: #ffffff;\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n}\n\n.contact-card-content h4 {\n  margin-bottom: 0.5rem;\n  font-size: 1.05rem;\n  color: #10375c;\n}\n\n.contact-card-content p {\n  margin: 0;\n  color: #5b6674;\n  line-height: 1.7;\n}\n\n.contact-us-page a {\n  color: #14b8a6;\n}\n\n.contact-section-grid {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 32px;\n  align-items: start;\n}\n\n.contact-us-form {\n  padding: 32px;\n  background: #ffffff;\n  border-radius: 30px;\n  box-shadow: 0 26px 70px rgba(15, 23, 42, 0.08);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.form-group-fullwidth {\n  grid-column: 1 / -1;\n}\n\n.contact-us-form .form-control {\n  width: 100%;\n  padding: 16px 18px;\n  border-radius: 16px;\n  background: #f7fafc !important;\n  border: 1px solid #dbe4ea;\n  color: #152a3a;\n}\n\n.contact-us-form .form-control:focus {\n  border-color: #0d9488;\n  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12) !important;\n}\n\n.contact-us-form .form-label {\n  color: #344054;\n  font-weight: 600;\n}\n\n.contact-us-page .contact-us-form .btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 14px 22px;\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  border-color: transparent;\n  color: #ffffff;\n  font-weight: 700;\n  border-radius: 16px;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.contact-us-page .contact-us-form .btn-secondary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 18px 40px rgba(20, 184, 166, 0.22);\n}\n\n.contact-aside-panel {\n  display: grid;\n  gap: 24px;\n}\n\n.contact-aside-card,\n.contact-map-card {\n  background: #ffffff;\n  border-radius: 28px;\n  padding: 28px;\n  box-shadow: 0 24px 62px rgba(15, 23, 42, 0.08);\n}\n\n.contact-aside-card h3 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  font-size: 1.4rem;\n  color: #092642;\n}\n\n.contact-aside-item {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.contact-aside-item:last-child {\n  margin-bottom: 0;\n}\n\n.contact-aside-icon {\n  width: 52px;\n  min-width: 52px;\n  height: 52px;\n  border-radius: 20px;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  color: #ffffff;\n  font-size: 1.2rem;\n}\n\n.contact-aside-item h4 {\n  margin: 0 0 6px;\n  font-size: 1rem;\n  color: #0f172a;\n}\n\n.contact-aside-item p {\n  margin: 0;\n  color: #5b6674;\n  line-height: 1.8;\n}\n\n.contact-map-card {\n  padding: 0;\n  overflow: hidden;\n}\n\n.contact-map-card iframe {\n  width: 100%;\n  height: 100%;\n  min-height: 340px;\n  border: none;\n  display: block;\n}\n\n.contact-dull-bg {\n  background: #f8fafc;\n  position: relative;\n  padding: 80px 0;\n}\n\n.contact-dull-bg h2 {\n  color: #092642;\n  font-weight: 700;\n  max-width: 640px;\n  font-size: clamp(2rem, 2.5vw, 2.5rem);\n  text-align: center;\n  margin: 0 auto 40px;\n}\n\n@media (max-width: 1024px) {\n  .contact-section-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-card-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-hero__body {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .contact-dull-bg {\n    padding: 60px 0;\n  }\n\n  .contact-us-form,\n  .contact-aside-card,\n  .contact-map-card {\n    border-radius: 24px;\n    padding: 24px;\n  }\n\n  .contact-aside-card h3 {\n    font-size: 1.25rem;\n  }\n\n  .contact-hero__title {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 576px) {\n  .contact-intro {\n    margin-bottom: 32px;\n  }\n\n  .contact-us-page .contact-us-form .btn-secondary {\n    padding: 14px;\n  }\n}\n\n.contact-us-page .details .info {\n  margin-left: 15px;\n}\n\n.contact-us-page .details .contact-icon {\n  width: 80px;\n  min-width: 80px;\n  height: 80px;\n  background: linear-gradient(93.86deg, #006177 -2.6%, #269089 67.39%, #7ABC82 110.84%);\n  border-radius: 10px;\n  font-size: 33px;\n  color: #FFFFFF;\n}\n\n.contact-us-page .details:hover .contact-icon {\n  background: linear-gradient(105.55deg, #7ABC82 -6.68%, #269089 43.13%, #085A6C 96.15%);\n}\n\n.contact-us-page .details .info p {\n  margin-bottom: 0;\n  color: #6B7385;\n  font-size: 15px;\n}\n\na {\n  color: #6B7385;\n  cursor: pointer;\n  text-decoration: none;\n  -webkit-transition: all 0.5s ease-in-out 0s;\n  -ms-transition: all 0.5s ease-in-out 0s;\n  transition: all 0.5s ease-in-out 0s;\n}\n\n.content.contact-group .google-maps {\n  margin-bottom: 80px;\n}\n\n.form-control:focus {\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.support-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.support-list li {\n  position: relative;\n  /* background: #111; */\n  color: #111;\n  margin-bottom: 12px;\n  padding: 14px 18px 14px 50px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  transition: 0.3s ease;\n  border: 1px solid #222;\n}\n\n.support-list li::before {\n  content: \"✔\";\n  position: absolute;\n  left: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 22px;\n  height: 22px;\n  background: #00c853;\n  border-radius: 50%;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.support-list li:hover {\n  transform: translateX(6px);\n  border-color: #333;\n}\n\n\n/* contact-form */\n.contact-dull-bg {\n  background: #F9F9F6;\n  position: relative;\n  padding: 80px 0;\n}\n\n.contact-dull-bg h2 {\n   color: #092642;\n  font-weight: 600;\n  max-width: 600px;\n  font-size: 32px;\n  text-align: center;\n  margin: 0 auto 16px;\n}\n\n.contact-us-form {\n  padding: 24px;\n  background: #FFFFFF;\n}\n\nform label.form-label {\n  margin-bottom: 10px;\n  color: #192335;\n}\n\nform label,\nform input {\n  color: #192335;\n}\n\nlabel {\n  display: inline-block;\n}\n\n\nh4 {\n  font-weight: 600;\n  font-size: 20px;\n  color: #192335;\n}\n\nform input.form-control,\nform textarea.form-control {\n  padding: 20px;\n  border-radius: 10px;\n  background: #f0f0f0 !important;\n  border: none;\n  font-weight: 500;\n}\n\n.contact-us-page .contact-us-form button {\n  margin: 24px auto 0 auto;\n}\n\n.contact-us-page .contact-us-form .btn-secondary {\n  color: #FFFFFF;\n  background: #00bfb4;\n  border-color: #00bfb4;\n}\n\n.contact-us-page .contact-us-form .btn {\n  font-size: 16px;\n  padding: 12px 20px;\n  font-weight: 500;\n  border-radius: 10px;\n  -webkit-transition: all 0.5s ease-in-out 0s;\n  -ms-transition: all 0.5s ease-in-out 0s;\n  transition: all 0.5s ease-in-out 0s;\n}\n\n/* contact-form */\n\n\n@media screen and (max-width: 1199.98px) {\n  .breadcrumb:before {\n    top: 24px;\n    left: 24px;\n  }\n\n  .breadcrumb span.primary-right-round {\n    top: 80px;\n  }\n}\n\n@media screen and (max-width: 991.98px) {\n  .contact-us-page .details {\n    margin-bottom: 15px;\n  }\n\n  h1 {\n    font-size: 32px;\n  }\n\n  .content.contact-group {\n    padding: 60px 0px 0px;\n  }\n\n  h2 {\n    font-size: 30px !important;\n  }\n\n  h4 {\n    font-size: 18px !important;\n  }\n}\n\n@media screen and (max-width: 767.98px) {\n  .content {\n    padding: 40px 0;\n  }\n\n  h2 {\n    font-size: 27px !important;\n  }\n\n}\n\n\n\n@media screen and (max-width: 676.98px) {\n  .contact-us-page .details svg {\n    height: 1.9rem !important;\n    width: 1.9rem !important;\n  }\n\n  .breadcrumb-item a {\n    font-size: 0.8rem !important;\n  }\n}\n\n@media(max-width: 575.98px){\n  .text-center{\n    padding: 0px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
